import React, { Component } from 'react';
import {
    Grid,
    Row,
    Col,
} from 'react-bootstrap';
import Card from '../../components/Card/Card.jsx';
import SweetAlert from "react-bootstrap-sweetalert";
import UncusaTab from './UncusaTab.jsx';
import IncubationService from "../../services/IncubationService";

class Main extends Component{
  constructor(props){
    super(props);
    this.state = {
        alert: null,
        key: 1,
        currentEquipo: null,
        tiposComprobantes: null,
    };
    this.incubationService = new IncubationService();
    this.errorAlert = this.errorAlert.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
  }

  hideAlert() {
    this.setState({
      alert: null
    });
  }
  errorAlert(message) {
    this.setState({
      alert: (
        <SweetAlert
          error
          style={{ display: "block", marginTop: "-100px" }}
          title="Error"
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="danger"
          confirmBtnText="Aceptar"
        >
          {message}
        </SweetAlert>
      )
    });
  }

  render(){
    return (
      <div className="main-content">
        {this.state.alert}
        <Grid fluid={true}>
          <Row>
            <Col md={12}>
              <Card
                content={
                  <div>
                    <UncusaTab
                      setError={this.errorAlert} incubationService={this.incubationService}
                      pushNotification={this.props.pushNotification}
                    />
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}
export default Main;



// WEBPACK FOOTER //
// ./src/views/Uncusa/Main.jsx